import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { DiagonalCornerModel } from '~/core/models';

const diagonalCornersService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchDiagonalCorners: builder.query<
      DiagonalCornerModel[],
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: ApiUrl.DIAGONAL_CORNERS,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useFetchDiagonalCornersQuery,
  useLazyFetchDiagonalCornersQuery,
} = diagonalCornersService;
